export const REFERRER_NAME = 'challenges'
export const DEFAULT_TERMS = 'https://thriveglobal.com/challenge/rules/'

export const FEATURE_FLAGS = {
    HAS_CHALLENGES_V2_ACCESS: 'HasChallengesV2Access',
    ACCENTURE_CHALLENGE_TEXT: 'AccentureChallengeText',
    SHOW_BE_WELL_GAMES: 'ShowBeWellGames'
} as const
